import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Alert } from "@mui/material";
import { LoginForm } from "../../components/auth";
import { useAuth } from "../../hooks";
import AuthLayout from "../../layouts/AuthLayout";

const LoginPage = () => {
  const { isAuthenticated, user, clearError } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as any)?.from?.pathname || "/";
  const resetSuccess = (location.state as any)?.resetSuccess || false;

  // Drop any auth error carried across the navigation boundary (e.g. a failed
  // reset attempt elsewhere) so it can't render alongside this screen's
  // banners. clearError is stable, so this runs once on mount.
  useEffect(() => {
    clearError();
  }, [clearError]);

  useEffect(() => {
    if (isAuthenticated) {
      if (user?.forcePasswordChange) {
        navigate("/auth/forced-password-reset", { replace: true });
      } else {
        navigate(from, { replace: true });
      }
    }
  }, [isAuthenticated, user, navigate, from]);

  return (
    <AuthLayout
      title="Welcome back"
      subtitle="Sign in to your account to continue"
      alert={
        resetSuccess && (
          <Alert severity="success" sx={{ mb: 2 }}>
            Password has been reset successfully!
          </Alert>
        )
      }
    >
      <LoginForm />
    </AuthLayout>
  );
};

export default LoginPage;
